module.exports = __webpack_public_path__ + "static/robot_parts-ac90ff1d8eb19200c02dd9852e336ca2.png";